'use strict';

/**
 *  Load modules
 */
import echo from './modules/echo.js';
import '../scss/app.scss';
$(document).ready(function () {
  var browserWidth = window.innerWidth || document.documentElement.clientWidth;

  //Stick header
  if (browserWidth > 960) {
    var stickHeader = function stickHeader() {
      if ($(window).scrollTop() > 1) {
        $('.header').addClass('header--stick');
      } else {
        $('.header').removeClass('header--stick');
      }
    };
    stickHeader();
    $(window).scroll(function () {
      stickHeader();
    });
  } else {
    $('.header').addClass('header--stick');
  }

  //copy to clipboard
  var toastMessage;
  if ($('html[lang="uk-UA"]').length) {
    toastMessage = 'Інформація скопійована в буфер обміну';
  } else {
    toastMessage = 'Information copied to clipboard';
  }
  function copyToClipboard(e) {
    console.log('copy');
    var copyElement = e.target.previousElementSibling;
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(copyElement).text()).select();
    document.execCommand("copy");
    $temp.remove();
    $.toast({
      message: toastMessage
    });
  }
  var toCopyBtn = document.querySelectorAll('.to-copy__btn');
  if (toCopyBtn) {
    toCopyBtn.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        return copyToClipboard(e);
      });
    });
  }

  //smooth scroll
  if ($("#donation").length != 0) {
    $(".smooth-scroll").click(function (e) {
      e.preventDefault();
      var id = $(this).attr('href');
      $('html,body').animate({
        scrollTop: $(id).offset().top - 100
      }, 700);
    });
  }

  //hide/show mobile menu
  $('.hide_show_menu').click(function () {
    $("body").toggleClass("mobile-menu-active");
  });
  if ($("#donation").length == 0) {
    $('.header__btn').attr('href', '/#donation');
  }
  (function (window, $) {
    "use strict";

    var defaultConfig = {
      container: '#toasts',
      autoDismissDelay: 4000,
      transitionDuration: 300
    };
    $.toast = function (config) {
      var size = arguments.length;
      var isString = typeof config === 'string';
      if (isString && size === 1) {
        config = {
          message: config
        };
      }
      if (isString && size === 2) {
        config = {
          message: arguments[1]
        };
      }
      return new toast(config);
    };
    var toast = function toast(config) {
      config = $.extend({}, defaultConfig, config);
      // show "x" or not
      var close = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.00072 5.58574L11.9507 0.635742L13.3647 2.04974L8.41472 6.99974L13.3647 11.9497L11.9507 13.3637L7.00072 8.41374L2.05072 13.3637L0.636719 11.9497L5.58672 6.99974L0.636719 2.04974L2.05072 0.635742L7.00072 5.58574Z" fill="white"/></svg>';

      // toast template
      var toast = $(['<div class="toast">', '<svg class="toast__icon" width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.00072 10.1715L16.1927 0.978516L17.6077 2.39252L7.00072 12.9995L0.636719 6.63552L2.05072 5.22152L7.00072 10.1715Z" fill="white"/></svg>', '<div class="toast__text">' + config.message + '</div>', '<div class="toast__close">' + close + '</div>', '</div>'].join(''));

      // handle dismiss
      toast.find('.toast__close').on('click', function () {
        var toast = $(this).parent();
        toast.addClass('hide');
        setTimeout(function () {
          toast.remove();
        }, config.transitionDuration);
      });

      // append toast to toasts container
      $(config.container).append(toast);

      // transition in
      setTimeout(function () {
        toast.addClass('show');
      }, config.transitionDuration);

      // dismiss, start counting
      setTimeout(function () {
        toast.find('.toast__close').click();
      }, config.autoDismissDelay);
      return this;
    };
  })(window, jQuery);
});